import { render, staticRenderFns } from "./v-sidebar-item.vue?vue&type=template&id=07d8cf7a&scoped=true&"
import script from "./v-sidebar-item.vue?vue&type=script&lang=js&"
export * from "./v-sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar-item.vue?vue&type=style&index=0&id=07d8cf7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8cf7a",
  null
  
)

export default component.exports